import http from "./httpService";
import session from "./sessionService";
import { apiUrl } from "../config";

http.setJwt(getJwt());

export async function login(email, password, rememberMe = false) {
  const response = await http.post(apiUrl + '/public-api/users/sign_in', { email, password, remember_me: rememberMe });
	session.storeToken(response.data.token);
  http.setJwt(response.data.token);
  return response
}

export async function requestRequestForgotPasswordEmail(email) {
  return await http.post(apiUrl + '/public-api/users/send_forgot_password', { email });
}

export async function forgotPasswordUpdate(id, code, new_password) {
  return await http.post(apiUrl + '/public-api/users/update_forgot_password', { 'RequestID': parseInt(id), 'Code': code, 'NewPassword': new_password });
}

export function loginWithJwt(jwt) {
	session.storeToken(jwt);
  http.setJwt(jwt);
}

export function clearLocalSession() {
	session.clearStoredToken();
  http.setJwt(null);
}

export async function logout() {
	if (!getJwt()) {
	  clearLocalSession();
	  return;
	}
  try {
    await http.post(apiUrl + '/api/me/logout', {});
  } finally {
    clearLocalSession();
  }
}

export function getCurrentUser() {
	return session.getCurrentUser();
}

export function getJwt() {
	const jwt = session.getValidToken();
	if (!jwt) http.setJwt(null);
	return jwt;
}

export default {
  login,
  loginWithJwt,
  logout,
  getCurrentUser,
  getJwt,
  requestRequestForgotPasswordEmail,
  forgotPasswordUpdate
};
